import { XMarkIcon } from "@heroicons/react/24/outline";

interface IRaisedContentProps {
  raised: boolean;
  title: string;
  content: string;
  toggleContent: React.MouseEventHandler<SVGSVGElement>;
}
const RaisedContent = ({
  raised,
  title,
  content,
  toggleContent,
}: IRaisedContentProps) => {
  const boxClasses = `${raised ? "" : " hidden"}`;
  return (
    <div className={boxClasses}>
      <div className="top-0 left-0 right-0 bottom-0 z-10 fixed bg-slate-950 opacity-80"></div>
      <div className="md:left-10 md:right-10 md:bottom-10 max-md:left-0 max-md:right-0 max-md: bottom-0 z-50 top-20 h-5/6 fixed bg-opacity-95 bg-black rounded-lg max-md:p-6 md:p-12">
        <XMarkIcon
          onClick={toggleContent}
          onPointerDown={toggleContent}
          className="right-4 absolute top-4 animate-bounce mx-auto text-9xl h-6 w-6 dark:text-white"
        />
        <h1
          className="text-2xl bold text-slate-50"
          style={{
            fontFamily: "Archivo Black",
          }}
        >
          {title}
        </h1>
        <br />
        <div className="overflow-scroll text-slate-50 left-0 right-0 bottom-0 top-0 h-full">
          <p
            className="text-xl font-normal"
            style={{ fontFamily: "Montserrat" }}
          >
            {content}
          </p>
        </div>
      </div>
    </div>
  );
};

export default RaisedContent;
